export const formatPrice = (price, currency = "EUR", lang = "it-IT", reverse = false) => {
  if ((price || price === 0) && lang !== "tr-TR") {
    const formattedPrice = Intl.NumberFormat(lang, {
      style: "currency",
      currency,
    }).format(parseFloat(price.toString().replace(",", ".")));
    return reverse ? formattedPrice.split(/\s/).reverse().join(" ") : formattedPrice;
  }
  if ((price || price === 0) && lang === "tr-TR") {
    const formattedPrice = Intl.NumberFormat(lang, {
      style: "currency",
      currency,
    }).format(parseFloat(price.toString().replace(",", ".")));
    return `${formattedPrice.slice(1)} TL`;
  }
  return price;
};

export const formatFilterPrice = (value, unit, lang = "it-IT") => {
  if (value && lang !== "tr-TR") {
    const formattedPrice = Intl.NumberFormat(lang, {
      style: "currency",
      currency: unit,
      minimumFractionDigits: 0,
    }).format(value);
    return formattedPrice;
  }
  if (value && lang === "tr-TR") {
    const formattedPrice = Intl.NumberFormat(lang, {
      style: "currency",
      currency: unit,
      minimumFractionDigits: 0,
    }).format(value);
    return `${formattedPrice.slice(1)} TL`;
  }
  return value;
};

export const getCurrencySymbol = (currency = "EUR", lang = "it-IT") => {
  return Intl.NumberFormat(lang, { style: "currency", currency })
    .formatToParts(1)
    .find((item) => item.type === "currency")?.value;
};
